import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';

import { AuthProvider } from 'contexts/authentication';
import { CountryConfigProvider } from 'contexts/country-config';
import { setupBrowser } from 'services/mocks';
import TokenService from 'services/token';
import { generateBentoTokenString } from 'utils/generate-bento-token-string';
import getConfig from 'utils/get-config';

import { App } from './App';

import './index.scss';

const config = getConfig();
const token = TokenService.getToken();
const queryClient = new QueryClient();

if (__ENABLE_API_MOCKS__ && Object.keys(config).length) {
  setupBrowser(config as Configuration);
}

const body = document.getElementsByTagName('body')[0];

if (body) {
  const bentoDesignTokenString = generateBentoTokenString(config.entity);
  body.style.cssText = bentoDesignTokenString;
}

const reactApp = (
  <React.StrictMode>
    <CountryConfigProvider config={config}>
      <AuthProvider accessToken={token}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </AuthProvider>
    </CountryConfigProvider>
  </React.StrictMode>
);

const rootElement = document.getElementById('root') as HTMLElement;

// default vite modes at https://vitejs.dev/guide/env-and-mode.html#modes
if (__APP_MODE__ === 'development') {
  ReactDOM.createRoot(rootElement).render(reactApp);
} else {
  ReactDOM.hydrateRoot(rootElement, reactApp);
}

// React version 17
// import { render } from 'react-dom'
// render(
//   <React.StrictMode>
//      <App />
//   </React.StrictMode>,
//   document.getElementById('root')!
// );
